import { onClickOutside } from "../common/helpers";

const HEIGHT = 0;
const MAX_HEIGHT = 500;

const toPixels = (value) => `${value}px`;

const initElement = ($el) => {
    const regions = $el.querySelectorAll('.ns-multiselect__regions li');
    const items = $el.querySelectorAll('.ns-multiselect__item');
    const $input = $el.querySelector(".ns-multiselect__input");
    const $title = $el.querySelector(".ns-multiselect__title");
    const $dropdown = $el.querySelector(".ns-multiselect__dropdown");
    const checkboxes = $el.querySelectorAll(".ns-checkbox__input");
    const quantityTargetCountriesSelected = $el.querySelector(".ns-multiselect__count");
    const selectAll = $el.querySelector(".ns-multiselect__select-all");
    const deselectAll = $el.querySelector(".ns-multiselect__deselect-all");
    const confirmSelection = $el.querySelector(".ns-multiselect__confirm-selection");
    const controlButton = $el.querySelector("button");
    let isOpened = false;
    let allValues = [];
    regions[0].classList.add('ns-multiselect__region--active');

    for (const checkbox of checkboxes) {
        allValues = [...allValues, checkbox.value];
    }

    const targetCountriesSelected = () => {
        let values = [];

        for (const checkbox of checkboxes) {
            if (checkbox.checked) {
                values = [...values, checkbox.value];
            }
        }

        return values;
    };

    const handleOpen = () => {
        if ($el.classList.contains('ns-multiselect--disabled')) {
            return;
        }

        let activeRegions = [];
        allValues = [];
        regions.forEach(region => {
            if (!region.classList.contains('ns-multiselect__region--off')) {
                activeRegions = [...activeRegions, region.dataset.region];
            }
        });

        for (const activeRegion of activeRegions) {
            for (const checkbox of $el.querySelectorAll(`.ns-multiselect__item[data-region='${activeRegion}'] input`)) {
                allValues = [...allValues, checkbox.value];
            }
        }

        controlButton.setAttribute('aria-expanded', 'true');
        if (controlButton.nextElementSibling.classList.contains("ns-multiselect__dropdown")){
            controlButton.nextElementSibling.removeAttribute('inert');
        }
        $el.classList.add("ns-multiselect--active");
        $dropdown.style.maxHeight = toPixels(MAX_HEIGHT);
    };

    const handleClose = () => {
        controlButton.setAttribute('aria-expanded', 'false');
        if (controlButton.nextElementSibling.classList.contains("ns-multiselect__dropdown")){
            controlButton.nextElementSibling.setAttribute('inert', 'true');
        }
        $el.classList.remove("ns-multiselect--active");
        $dropdown.style.maxHeight = HEIGHT;
    };

    const handleChangeRegion = (activeRegion) => {
        for (const region of regions) {
            region.classList.remove('ns-multiselect__region--active');
        }

        activeRegion.classList.add('ns-multiselect__region--active');

        let countriesRegion = 0;
        let countriesRegionChecked = 0;

        for (const item of items) {
            if (item.dataset.region === activeRegion.dataset.region) {
                item.style.display = 'list-item';
                countriesRegion++;

                if (item.querySelector('input').checked) {
                    countriesRegionChecked++;
                }
            } else {
                item.style.display = 'none';
            }
        }

        if (countriesRegion === countriesRegionChecked) {
            selectAll.style.display = 'none';
            deselectAll.style.display = 'block';
        } else {
            selectAll.style.display = 'block';
            deselectAll.style.display = 'none';
        }
    };

    const dispatchOnChange = (value) => {
        $el.dispatchEvent(
            new CustomEvent("on-change", {
                detail: {
                    value,
                },
            })
        );
    };

    const setValue = (value = []) => {
        const title = $title.dataset.title;

        $input.value = value.join(",");

        if (title) {
            if (value.length === 0) {
                $title.textContent = $title.ariaLabel = title;
            } else if (value.length === 1) {
                $title.textContent = $el.querySelector(`.ns-checkbox__input[value='${value[0]}']`).dataset.textValue;
                $title.ariaLabel = `${title}: ${$title.textContent}`;
            } else {
                $title.textContent = `${value.length} ${title}`;
                $title.ariaLabel = `${title}: ${$title.textContent}`;
            }
        }

        const activeRegion = $el.querySelector('.ns-multiselect__region--active').dataset.region;
        const countCountriesChecked = $el.querySelectorAll(`.ns-multiselect__list li[data-region="${activeRegion}"] input:checked`).length;
        const countCountries = $el.querySelectorAll(`.ns-multiselect__list li[data-region="${activeRegion}"]`).length;

        quantityTargetCountriesSelected.textContent = value.length;

        if (countCountriesChecked !== countCountries) {
            selectAll.style.display = 'block';
            deselectAll.style.display = 'none';
        } else {
            selectAll.style.display = 'none';
            deselectAll.style.display = 'block';
        }

        dispatchOnChange(value);
    };

    const handleAddValue = (value) => {
        const $checkbox = $el.querySelector(`[value="${value}"]`);

        if (!$checkbox) {
            return;
        }

        $checkbox.checked = true;

        setValue(targetCountriesSelected());
    };

    const handleRemoveValue = (value) => {
        const $checkbox = $el.querySelector(`[value="${value}"]`);

        if (!$checkbox) {
            return;
        }

        $checkbox.checked = false;

        setValue(targetCountriesSelected());
    };

    const handleClearValue = () => {
        setValue([])

        checkboxes.forEach(($checkbox) => {
            $checkbox.checked = false;
        });

        dispatchOnChange("");
    };

    const handleChange = (event, $checkbox) => {
        const value = $checkbox.value;

        if (event.currentTarget.checked) {
            handleAddValue(value);
        } else {
            handleRemoveValue(value);
        }
    };

    const handleSelectAll = () => {
        const activeRegion = $el.querySelector('.ns-multiselect__region--active').dataset.region;
        const countries = $el.querySelectorAll(`.ns-multiselect__list li[data-region="${activeRegion}"] input:not(:checked)`);

        for (const country of countries) {
            country.click();
        }
    };

    const handleDeselectAll = () => {
        const activeRegion = $el.querySelector('.ns-multiselect__region--active').dataset.region;
        const countries = $el.querySelectorAll(`.ns-multiselect__list li[data-region="${activeRegion}"] input:checked`);

        for (const country of countries) {
            country.click();
        }
    };

    regions.forEach(region => {
        region.addEventListener('click', () => handleChangeRegion(region));
    });

    $title.addEventListener("click", () => {
        if (isOpened === false) {
            handleOpen();
        } else {
            handleClose();
        }

        isOpened = !isOpened;
    });

    onClickOutside($el, () => {
        handleClose();

        isOpened = false;
    });

    checkboxes.forEach(($checkbox) => {
        $checkbox.addEventListener("change", (event) => {
            handleChange(event, $checkbox);
        });
    });

    $el.addEventListener("handle-remove-value", ({ detail }) => {
        const { value } = detail;

        if (!value) {
            return;
        }

        handleRemoveValue(value);
    });

    $el.addEventListener("handle-add-value", ({ detail }) => {
        const { value } = detail;

        if (!value) {
            return;
        }

        handleAddValue(value);
    });

    $el.addEventListener("handle-clear-value", handleClearValue);
    selectAll.addEventListener('click', handleSelectAll);
    deselectAll.addEventListener('click', handleDeselectAll);
    confirmSelection.addEventListener('click', () => $el.querySelector('.ns-multiselect__title').click());
};

const initElementMobile = ($el) => {
    const title = $el.querySelector('.ns-multiselect-mobile__title');
    const tag = title.dataset.tag;
    const frame = document.querySelector(`.ns-multiselect-mobile__frame[data-tag='${tag}']`);
    const back = frame.querySelector('.ns-multiselect-mobile__frame-top-back');
    const selectAll = frame.querySelector('.ns-multiselect-mobile__frame-top-all-select');
    const deselectAll = frame.querySelector('.ns-multiselect-mobile__frame-top-all-deselect');
    const tabs = frame.querySelectorAll('.ns-multiselect-mobile__frame-tab');
    const items = frame.querySelectorAll('.ns-multiselect-mobile__frame-list-item');
    const inputs = frame.querySelectorAll(".ns-checkbox__input");
    const confirmSelection = frame.querySelector('.ns-multiselect-mobile__frame-confirm');
    let isOpened = false;

    const handleOpen = () => {
        if ($el.classList.contains('ns-multiselect-mobile--disabled')) {
            return;
        }

        frame.classList.add("ns-multiselect-mobile__frame--active");
        isOpened = true;
    };

    const handleBack = () => {
        frame.classList.remove("ns-multiselect-mobile__frame--active");
        isOpened = false;
    }

    const handleSelectAll = () => {
        const targetRegionActive = frame.querySelector('.ns-multiselect-mobile__frame-tab--active').dataset.region;
        const targetCountriesRegionActive = frame.querySelectorAll(`.ns-multiselect-mobile__frame-list-item[data-region='${targetRegionActive}'] input:not(:checked)`);

        for (const targetCountryRegionActive of targetCountriesRegionActive) {
            targetCountryRegionActive.click();
        }
    }

    const handleDeselectAll = () => {
        const targetRegionActive = frame.querySelector('.ns-multiselect-mobile__frame-tab--active').dataset.region;
        const targetCountriesRegionActive = frame.querySelectorAll(`.ns-multiselect-mobile__frame-list-item[data-region='${targetRegionActive}'] input:checked`);

        for (const targetCountryRegionActive of targetCountriesRegionActive) {
            targetCountryRegionActive.click();
        }
    }

    const handleChangeRegion = (e) => {
        for (const tab of tabs) {
            if (tab.dataset.region === e.currentTarget.dataset.region) {
                tab.classList.add('ns-multiselect-mobile__frame-tab--active');
            } else {
                tab.classList.remove('ns-multiselect-mobile__frame-tab--active');
            }
        }

        let countCountriesRegionActive = 0;
        let countCountriesRegionChecked = 0;

        for (const item of items) {
            if (item.dataset.region === e.currentTarget.dataset.region) {
                item.style.display = 'list-item';
                countCountriesRegionActive++;

                if (item.querySelector('input:checked')) {
                    countCountriesRegionChecked++;
                }
            } else {
                item.style.display = 'none';
            }
        }

        if (countCountriesRegionChecked === countCountriesRegionActive) {
            selectAll.style.display = 'none';
            deselectAll.style.display = 'block';
        } else {
            selectAll.style.display = 'block';
            deselectAll.style.display = 'none';
        }
    }

    const handleChange = () => {
        const regionActive = frame.querySelector('.ns-multiselect-mobile__frame-tab--active');

        if (!regionActive) {
            return;
        }

        const targetRegionActive = regionActive.dataset.region;
        const countCountriesRegionActive = frame.querySelectorAll(`.ns-multiselect-mobile__frame-list-item[data-region='${targetRegionActive}'] input`).length;
        const countCountriesRegionChecked = frame.querySelectorAll(`.ns-multiselect-mobile__frame-list-item[data-region='${targetRegionActive}'] input:checked`).length;

        if (countCountriesRegionChecked === countCountriesRegionActive) {
            selectAll.style.display = 'none';
            deselectAll.style.display = 'block';
        } else {
            selectAll.style.display = 'block';
            deselectAll.style.display = 'none';
        }
    };

    title.addEventListener('click', handleOpen);
    back.addEventListener('click', handleBack);
    selectAll.addEventListener('click', handleSelectAll);
    deselectAll.addEventListener('click', handleDeselectAll);

    for (const tab of tabs) {
        tab.addEventListener('click', e => handleChangeRegion(e));
    }

    for (const input of inputs) {
        input.addEventListener('change', handleChange);
    }

    confirmSelection.addEventListener('click', handleBack);
};

const init = () => {
    const multiselects = document.querySelectorAll(".ns-multiselect__big");
    const multiselectsMobile = document.querySelectorAll(".ns-multiselect-mobile--big");

    multiselects.forEach(($el) => {
        initElement($el);
    });
    multiselectsMobile.forEach(($el) => {
        initElementMobile($el);
    });
};

window.addEventListener("DOMContentLoaded", init, false);
